// extracted by mini-css-extract-plugin
export var cols2 = "CardGroup-module--cols2--d936a";
export var cols3 = "CardGroup-module--cols3--aa8aa";
export var cols4 = "CardGroup-module--cols4--fa602";
export var root = "CardGroup-module--root--c5138";
export var spacing1x = "CardGroup-module--spacing1x--3e4d9";
export var spacing2x = "CardGroup-module--spacing2x--0b944";